import { api } from '$app/api';

export function GetAssociationsByExternalIdRequest(SKUs) {
  return api
    .post(`/speciality`, {
      eventType: 'GetAssociationsByExternalIdRequest',
      body: {
        externalIds: SKUs,
      },
    })
    .then((res) => res.data);
}

export function BatchGetTimetableRules(timetableIds) {
  return api.post(`timetable/rules`, {
    eventType: 'BatchGetTimetableRulesRequest',
    body: {
      timetableIds,
    },
  });
}
